// Sidebar items flagged superAdminOnly are shown only to a super admin
// (batch H, H1). Pass false during View As: the viewed user's menu applies.
// Groups left with no items are dropped.
export function visibleNavGroups(groups, isSuperAdmin) {
  return (groups || [])
    .map(g => ({ ...g, items: (g.items || []).filter(i => !i.superAdminOnly || isSuperAdmin) }))
    .filter(g => g.items.length > 0);
}
